/**
 * 协议收发日志记录器。
 *
 * DevTools 控制台在未打开时只保留有限缓冲，偶发 bug 的关键日志经常被冲掉；
 * 这里独立维护一份从页面加载起的完整收发时间线（内存环形缓冲），
 * 供调试面板展示和一键导出，不依赖控制台是否打开。
 */

const MAX_ENTRIES = 5000;

const entries = [];
let seq = 0;

function formatTime(date) {
  const pad = (n, w = 2) => String(n).padStart(w, '0');
  return (
    `${pad(date.getHours())}:${pad(date.getMinutes())}:` +
    `${pad(date.getSeconds())}.${pad(date.getMilliseconds(), 3)}`
  );
}

function toHex(bytes) {
  if (!bytes || !bytes.length) return '';
  return Array.from(bytes, (b) =>
    b.toString(16).padStart(2, '0').toUpperCase()
  ).join(' ');
}

/**
 * 记录一条协议事件
 * @param {'tx'|'rx'|'event'|'error'} kind - tx=发送 rx=接收 event=流程事件 error=错误
 * @param {string} detail - 描述（如端点信息、路由去向、重发进度）
 * @param {Uint8Array} [bytes] - 相关的原始数据包
 */
export function recordProtocol(kind, detail, bytes) {
  entries.push({
    seq: ++seq,
    time: formatTime(new Date()),
    kind,
    detail,
    hex: bytes ? toHex(bytes) : '',
  });
  if (entries.length > MAX_ENTRIES) {
    entries.shift();
  }
}

/** 当前所有日志条目（按时间顺序） */
export function getProtocolLogEntries() {
  return entries.slice();
}

/** 导出为纯文本 */
export function formatProtocolLog() {
  return entries
    .map((e) =>
      [
        `#${e.seq}`,
        e.time,
        e.kind.toUpperCase().padEnd(5),
        e.detail,
        e.hex ? `\n    ${e.hex}` : '',
      ].join(' ')
    )
    .join('\n');
}

/** 触发浏览器下载日志文件 */
export function downloadProtocolLog() {
  const blob = new Blob([formatProtocolLog()], {
    type: 'text/plain;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `protocol-log-${Date.now()}.txt`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function clearProtocolLog() {
  entries.length = 0;
}

// 控制台随时可用：window.__exportProtocolLog() 直接下载完整时间线
if (typeof window !== 'undefined') {
  window.__exportProtocolLog = downloadProtocolLog;
  window.__protocolLogEntries = getProtocolLogEntries;
}
